import {
  Component, ViewChild,
  OnInit,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { Order } from '../interfaces/order';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MatPaginator, MatSort, Sort, PageEvent, MatInput, MatSortable, MatDialog } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DataService } from '../../services/data.service';
import { Observable } from 'rxjs/Observable';
import { OrderEntry } from '../models/order.model';
import { ConfigService } from '../../services/config.service';
import { DeleteOrderDialogComponent } from '../components/delete-order-dialog/delete-order-dialog.component';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent implements OnInit, OnDestroy {

  // For the mat-table
  displayedColumns = ['orderNr', 'project', 'date', 'vendor', 'total', 'invoiceCompletion', 'ddtCompletion', 'ddt', 'status', 'authorized', 'driveUrl', 'actions'];
  dataSource: OrderDataSource;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('fromDate', {
    read: MatInput
  }) fromDate: MatInput;

  @ViewChild('toDate', {
    read: MatInput
  }) toDate: MatInput;

  private orderStream$;
  private dataSubscription;
  private _pageSize = 50;
  public todayDate;
  public dateInSevenDays;

  // Flags
  public orderPrepare = new Map<string, boolean>();

  get showPending(): boolean {
    if (this.dataSource) {
      return this.dataSource.showPending;
    }
  }

  get pageSize(): number {
    return this._pageSize;
  }

  get showUrgent(): boolean {
    if (this.dataSource) {
      return this.dataSource.showUrgent;
    }
  }

  get showAuthorized(): boolean {
    if (this.dataSource) {
      return this.dataSource.showAuthorized;
    }
  }

  constructor(
    private dataService: DataService,
    private configService: ConfigService,
    private datePipe: DatePipe,
    private router: Router,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.todayDate = this.createTodayDate();
    const todayPlusSevenDays = this.addDays(this.todayDate, 8);
    this.dateInSevenDays = todayPlusSevenDays.getTime();

    this.orderStream$ = this.dataService.getOrderList()
      .map((orderList) => orderList.map((order) => {
        const data = order.payload.doc.data() as Order;
        const id = order.payload.doc.id;
        const urgent = this.isUrgentOrder(data);
        const ddtList = this.setDeliveryNotesList(data);
        return { id: id, urgent: urgent, ddtList: ddtList, ...data };
      }));

    // Assign the data to the data source for the table to render
    this.dataSource = new OrderDataSource(
      this.orderStream$,
      this.paginator, this.sort);

    this.dataSource.showPending = localStorage.getItem('showPending') ? localStorage.getItem('showPending') == 'true' : false;
    this.dataSource.showAuthorized = localStorage.getItem('showAuthorized') ? localStorage.getItem('showAuthorized') == 'true' : false;
    this.dataSource.showUrgent = localStorage.getItem('showUrgent') ? localStorage.getItem('showUrgent') == 'true' : false;
    this._pageSize = localStorage.getItem('pageSize') ? +localStorage.getItem('pageSize') : 50;


    let sortDirection;
    switch (localStorage.getItem('orderListSortDirection')) {
      case 'asc':
        sortDirection = 'asc';
        break;
      default:
        sortDirection = 'desc';
    }

    console.log('##### SORT DIRECTION:', sortDirection);

    const matSortable: MatSortable = {
      id: localStorage.getItem('orderListSortId') ? localStorage.getItem('orderListSortId') : 'date',
      start: sortDirection,
      disableClear: false
    };
    this.sort.sort(matSortable);

    // this.sort.sortChange.subscribe((sortStatus: Sort) => {
    //   if (sortStatus) {
    //     localStorage.setItem('orders.sort.active', sortStatus.active);
    //     localStorage.setItem('orderListSortDirection', sortStatus.direction);
    //   }
    // });


    console.log('get pageSize:', this._pageSize);
  }

  public getOrderListFilter() {
    let orderListFilter = localStorage.getItem('orderListFilter') ? localStorage.getItem('orderListFilter') : '';
    this.applyFilter(orderListFilter);
    return orderListFilter;
  }

  public setOrderListFilter(filterName, filterValue) {
    localStorage.setItem(filterName, filterValue);
  }

  public ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }

  private isUrgentOrder(order) {
    let deliveryDate = moment(order.deliveryDate).toDate();
    return (order.deliveryDate && deliveryDate >= this.todayDate && deliveryDate <= this.dateInSevenDays) && (!order.orderDeliveryCompletion || order.orderDeliveryCompletion < 100);
  }

  private setDeliveryNotesList(order) {
    let ddtList = [];
    if (order.items) {
      ddtList = this.setDdtList(order.items);
    }

    // only unique ddt
    const filteredDdtList = this.setFilteredDdtList(ddtList);
    return filteredDdtList;
  }

  private setDdtList(items) {
    const ddtList = [];
    items.forEach(item => {
      if (item.ddt && item.ddt.length > 0) {
        item.ddt.forEach(ddt => {
          const ddtDetail = {
            ddtId: ddt.ddtId,
            ddtNr: ddt.ddtNr,
            ddtDate: ddt.ddtDate
          };
          ddtList.push(ddtDetail);
        });
      }
    });

    return ddtList;
  }

  private setFilteredDdtList(ddtList) {
    const filteredDdtList = Array.from(new Set(ddtList.map(ddt => ddt.ddtId)))
      .map(ddtId => {
        return {
          ddtId: ddtId,
          ddtNr: ddtList.find(ddt => ddt.ddtId === ddtId).ddtNr,
          ddtDate: ddtList.find(ddt => ddt.ddtId === ddtId).ddtDate
        };
      });

    return filteredDdtList;
  }

  public deleteOrder(order: Order) {
    console.log('Delete order', order);
    
    const dialogRef = this.dialog.open(DeleteOrderDialogComponent, {
      width: '500px',
      data:{
        order: order
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataService.deleteOrder(order)
      .then(() => {
        console.log('Order deleted');
      })
      .catch((err) => {
        console.error('Error while removing order', err.message);
      });
      } else {
        console.log('not deleted');
      }
    });


    
  }

  public orderHasInvoices(order: Order){
    return order.items ? order.items.some(it => {
      return it.invoices && it.invoices.length > 0;
    }) : false;
  }

  public prepareOrder(order: Order) {
    this.orderPrepare.set(order.id, true);

    const sett = this.configService.settings.value;
    const targetFolder = sett.value.googleDrive.orderRootFolder;
    const orderModel = sett.value.googleDrive.orderModel;

    // Data Ordine
    const orderDate = moment.isDate(order.date) ? moment.tz(order.date, 'Europe/Rome').format('DD/MM/YYYY') : '';
    const deliveryNoteDate = (order.deliveryNote && moment.isDate(order.deliveryNote.date)) ?
      moment.tz(order.deliveryNote.date, 'Europe/Rome').format('DD/MM/YYYY') : '';
    const invoiceDate = (order.invoice && moment.isDate(order.invoice.date)) ?
      moment.tz(order.invoice.date, 'Europe/Rome').format('DD/MM/YYYY') : '';
    const deliveryDate = moment.isDate(order.deliveryDate) ? moment.tz(order.deliveryDate, 'Europe/Rome').format('DD/MM/YYYY') : '';

    const param = {
      // id_modello: '1fEz7hIsCjPkN9H6pmylwj0aErYqirCtmkVdu1hW4LM0',
      // id_cartella_destinazione: '1PQTMPnrou9JHo0SxpJc13vBSInJdW9cY',
      id_modello: orderModel,
      id_cartella_destinazione: targetFolder,
      nome_documento: order.orderNr,
      azione: 'sostituzione',
      autore_ordine: order.author.displayName,
      nr_ordine: order.orderNr,
      data_ordine: orderDate, // BOH
      destinatario: order.vendor.name,
      persona_riferimento: order.primaryContact ? order.primaryContact.name : undefined,
      indirizzo_destinatario: order.vendor.address ? order.vendor.address.street : '',
      località_destinatario: order.vendor.address ? order.vendor.address.city : '',
      lista_oggetti: order.items.map((entry, i) => {
        return {
          qta: entry.quantity,
          prezzo_unitario: entry.costEach,
          descrizione: entry.description,
          um: entry.unit,
          sconto: entry.discount / 100, // percent,
          codice: entry.code,
          tick: 0,
          riga: i + 1,
          commessa: entry.budget.project ? entry.budget.project.projectNr : entry.budget.budgetNr
        };
      }),
      note: order.note,
      totale_imponibile: order.totalValue,
      trasporto: order.shippingMethod,
      pagamento: order.paymentMethod,
      resa: order.returnMethod,
      consegna: deliveryDate,
      iva: order.vat / 100,
      esenzione_iva: (order.vat === 0) ? 'In esenzione IVA ai sensi dell\'art 8 lett. C DPR 633/72, seguirà lettera di intento' : '',
      nr_DDT: order.deliveryNote ? order.deliveryNote.deliveryNoteNr : undefined,
      data_DDT: deliveryNoteDate,
      motivo_DDT: order.deliveryNote ? order.deliveryNote.reason : undefined,
      nr_fattura: order.invoice ? order.invoice.invoiceNr : undefined,
      data_fattura: invoiceDate,
    };
    this.dataService.prepareOrder(param)
      .subscribe((res) => {
        console.log('Order prepared', res);
        if (res.response.result.returnCode) {
          console.warn('There was an error', res.response.result.returnCode);
        } else if (res.response.result.orderUrl) {
          this.dataService.patchOrder(order.id, { driveUrl: res.response.result.orderUrl });
        }
        this.orderPrepare.set(order.id, false);

      },
        (err) => {
          console.warn('There was an error');
          this.orderPrepare.set(order.id, false);
        });
  }

  public prepareOrderPdf(order: Order) {
    this.orderPrepare.set(order.id, true);
    this.dataService.prepareOrderPdf(order.id).first()
      .subscribe((res) => {
        console.log('Order prepared', res);
        const patchData: any = {};
        if (res.document && res.document.webViewLink) {
          patchData.driveUrl = res.document.webViewLink;
        }
        if (res.draft && res.draft.message) {
          patchData.draftMessage = res.draft.message;
        }
        this.dataService.patchOrder(order.id, patchData);
        this.orderPrepare.set(order.id, false);

      },
        (err) => {
          console.warn('There was an error', err);
          this.orderPrepare.set(order.id, false);
        });
  }

  public askOrderAuth(order: Order) {
    this.orderPrepare.set(order.id, true);
    this.dataService.askOrderAuth(order).first()
      .subscribe((res) => {
        console.log('Authorization asked', res);
        this.orderPrepare.set(order.id, false);
      },
        (err) => {
          console.warn('There was an error', err);
          this.orderPrepare.set(order.id, false);
        });
  }

  createTodayDate() {
    var today = new Date();
    today.setDate(today.getDate() - 1);
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    var day = today.getDate();
    return new Date(year + "-" + month + "-" + day).getTime();
  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  savePageSize(pageLength: any) {
    if (pageLength && pageLength.pageSize) {
      this._pageSize = pageLength.pageSize;
      localStorage.setItem('pageSize', pageLength.pageSize.toString());
    }
  }

  applyShowPending(showPending: any) {
    this.dataSource.showPending = showPending.checked;
    localStorage.setItem('showPending', showPending.checked.toString());
  }

  applyShowUrgent(showUrgent: any) {
    this.dataSource.showUrgent = showUrgent.checked;
    localStorage.setItem('showUrgent', showUrgent.checked.toString());
  }

  applyShowAuthorized(showAuthorized: any) {
    this.dataSource.showAuthorized = showAuthorized.checked;
    localStorage.setItem('showAuthorized', showAuthorized.checked.toString());
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
    // set cookie
    this.setOrderListFilter('orderListFilter', filterValue);
  }

  filterByFromDate(filterValue: Date) {
    let fromDate = new Date(filterValue).getTime();
    this.dataSource.filterFromValidDate = fromDate;
  }

  filterByToDate(filterValue: Date) {
    let toDate = new Date(filterValue).getTime();
    this.dataSource.filterToValidDate = toDate;
  }

  resetDatePicker() {
    this.fromDate.value = '';
    this.dataSource.filterFromValidDate = undefined;
    this.toDate.value = '';
    this.dataSource.filterToValidDate = undefined;
  };

}


/**
* Data source to provide what data should be rendered in the table. Note that the data source
* can retrieve its data in any way. In this case, the data source is provided a reference
* to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
* the underlying data. Instead, it only needs to take the data and send the table exactly what
* should be rendered.
*/
class OrderDataSource extends DataSource<Order> {

  _filterChange = new BehaviorSubject('');
  _showPending = new BehaviorSubject(false);
  _showUrgent = new BehaviorSubject(false);
  _showAuthorized = new BehaviorSubject(false);
  _filterFromValidDateChange = new BehaviorSubject(undefined);
  _filterToValidDateChange = new BehaviorSubject(undefined);
  _dataChange = new BehaviorSubject([]);
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }
  get filterFromValidDate(): number { return this._filterFromValidDateChange.value; }
  set filterFromValidDate(filterFromValidDate: number) { this._filterFromValidDateChange.next(filterFromValidDate); }
  get filterToValidDate(): number { return this._filterToValidDateChange.value; }
  set filterToValidDate(filterToValidDate: number) { this._filterToValidDateChange.next(filterToValidDate); }

  get showPending(): boolean { return this._showPending.value; }
  set showPending(se: boolean) { this._showPending.next(se); }
  get showUrgent(): boolean { return this._showUrgent.value; }
  set showUrgent(se: boolean) { this._showUrgent.next(se); }
  get showAuthorized(): boolean { return this._showAuthorized.value; }
  set showAuthorized(se: boolean) { this._showAuthorized.next(se); }


  // The number of issues returned by github matching the query.
  public resultsLength = 0;
  public isLoadingResults = false;

  constructor(private observable,
    private _paginator: MatPaginator,
    private _sort: MatSort) {
    super();
    this.observable
      // .do((data) => console.log(data))
      .subscribe(this._dataChange);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Order[]> {
    // Listen for any changes in the base data, sorting, filtering, or pagination
    const displayDataChanges = [
      this.observable,
      this._sort.sortChange,
      this._filterChange.debounceTime(500),
      this._showPending,
      this._showUrgent,
      this._showAuthorized,
      this._filterFromValidDateChange,
      this._filterToValidDateChange,
      this._paginator.page,
    ];

    this._paginator._changePageSize(Number(localStorage.getItem('orderListPageSize')))
    this._paginator.page.next(new PageEvent());
    this._paginator.page.subscribe(paginationData => {
      localStorage.setItem('orderListPageSize', paginationData.pageSize);
    })

    // const sortId = localStorage.getItem('orderListSortId');
    // const sortDirection = localStorage.getItem('orderListSortDirection');

    // console.log('#### Other sort direction: ', sortDirection)

    // //this._sort.sort(({ id: sortId, start: sortDirection }) as MatSortable);

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this._dataChange.value;

      // Filter
      const fData = data.filter((item: Order) => {
        let srcStr: string;
        let fromValidDate;
        let toValidDate;
        try {
          const timestampDate = this.extractDateFromTimestamp(item.date);
          fromValidDate = this.filterFromValidDate ? timestampDate >= this.filterFromValidDate : true;
          toValidDate = this.filterToValidDate ? timestampDate <= this.filterToValidDate : true;
          srcStr = item.items.map(entry => entry.budget.project.projectNr).join('-') +
            item.items.map(entry => entry.description).join('-');
        } catch (err) {
          srcStr = '';
        }

        let filterPending = true;
        if (this.showPending) {
          filterPending = (!item.orderDeliveryCompletion || (item.orderDeliveryCompletion && item.orderDeliveryCompletion < 100));
        }

        let filterUrgent = true;
        if (this.showUrgent) {
          filterUrgent = item.urgent;
        }

        let filterAuthorized = true;
        if (this.showAuthorized) {
          filterAuthorized = item.authorized == 'waiting';
        }

        const searchStr = (srcStr + item.vendor.name + item.orderNr).toLowerCase();
        return (searchStr.indexOf(this.filter.toLowerCase()) !== -1) && filterPending && filterUrgent && filterAuthorized && fromValidDate && toValidDate;
      });

      this.resultsLength = fData.length;
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      this.sortData(fData);
      return fData.splice(startIndex, this._paginator.pageSize);
    });

  }

  extractDateFromTimestamp(date) {
    let dateTime = new Date(date.toString());
    let year = dateTime.getFullYear();
    let month = dateTime.getMonth() + 1;
    let day = dateTime.getDate();
    return new Date(year + "-" + month + "-" + day).getTime();
  }

  disconnect() { }

  private sortData = (timereport: Order[]) => {
    // console.log('sort ', this._sort.active, this._sort.direction);
    
    if (this._sort.active === undefined || this._sort.direction === undefined) {
      return;
    }

    localStorage.setItem('orderListSortId', this._sort.active);
    localStorage.setItem('orderListSortDirection', this._sort.direction);

    timereport.sort((a: Order, b: Order) => {

      let propertyA: number | string | Date | boolean;
      let propertyB: number | string | Date | boolean;

      switch (this._sort.active) {
        // case 'budget':
        //   // const abid = (typeof a.budget === 'object') ? a.budget.budgetNr : a.budget;
        //   // const bbid = (typeof b.budget === 'object') ? b.budget.budgetNr : b.budget;
        //   [propertyA, propertyB] = [abid, bbid];
        //   break;

        //orderNr', 'project', 'date', 'vendor', 'total', 'invoiceCompletion', 'ddtCompletion', 'ddt', 'status', 'authorized', 'driveUrl', 'actions'
        case 'orderNr': [propertyA, propertyB] = [a.orderNr, b.orderNr]; break;
        case 'project':
          propertyA = Array.isArray(a.projects) ? a.projects.join() : '';
          propertyB = Array.isArray(b.projects) ? b.projects.join() : '';
          break;
        case 'vendor': [propertyA, propertyB] = [a.vendor.name, b.vendor.name]; break;
        case 'ddtCompletion': [propertyA, propertyB] = [a.orderDeliveryCompletion, b.orderDeliveryCompletion]; break; //broken
        case 'date': [propertyA, propertyB] = [<Date>a.date, <Date>b.date]; break;
        case 'author': [propertyA, propertyB] = [a.author.email, b.author.email]; break;
        case 'total': [propertyA, propertyB] = [a.totalValue, b.totalValue]; break; //broken
        case 'invoiceCompletion': [propertyA, propertyB] = [a.orderInvoiceCompletion, b.orderInvoiceCompletion]; break; //broken
        case 'status': [propertyA, propertyB] = [a.urgent, b.urgent]; break;
        case 'authorized': [propertyA, propertyB] = [a.authorized, b.authorized]; break; //broken
        case 'driveUrl': [propertyA, propertyB] = [a.driveUrl, b.driveUrl]; break; //broken
      }


      let valueA;
      let valueB;

      if (propertyA instanceof Date) {
        valueA = propertyA;
        valueB = propertyB;
      } else if (this._sort.active === 'project') {
        valueA = propertyA;
        valueB = propertyB;
      } else {
        valueA = isNaN(+propertyA) ? propertyA : +propertyA;
        valueB = isNaN(+propertyB) ? propertyB : +propertyB;
      }

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/order/order-list/order-list.component.ts